export default "__VITE_ASSET__CdSyg1e$__"